<template>
    <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <div class="col-7 text-left">
                <h4 class="card-title pb-2 pt-2 mb-0">Report Divisi Peserta Magang</h4>
            </div>
            <div class="col-5">
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-7">
                <input type="text"
                    class="form-control"
                    v-model="divisi"
                    placeholder="Cari Divisi / Nama VP / Nama GM"
                >
            </div>
            <div class="col-3">
                <month-picker-input placeholder="Bulan, Tahun" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
            </div>
            <div class="col-2">
                <CButton @click="getData()" type="button" class="w-100 btn btn-primary">Cari</CButton>
            </div>
        </div>
        <div class="row no-gutters mt-3">
            <div class="col-2">
            </div>
            <div class="col-4"></div>
            <div class="col-6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
            </div>
        </div>
        <div class="row mt-3 pb-5 no-gutters">
            <div class="col-12">
                <table class="table w-100 table-bordered table-light table-hover" style="border-color:gainsboro!important">
                    <thead>
                        <tr>
                            <th style="border-color:gainsboro!important;text-align:center">Nama Divisi</th>
                            <th style="border-color:gainsboro!important;text-align:center">Jumlah Peserta</th>
                            <th style="border-color:gainsboro!important;text-align:center">Total Uang Saku</th>
                        </tr>
                    </thead>
                    <tbody v-if="datas.length != 0">
                        <tr v-for="(list, id) in datas" :key="id">
                            <td style="border-color:gainsboro!important" class="font-weight-bold">{{list.divisi}}</td>
                            <td style="border-color:gainsboro!important;text-align:center">{{list.totalMagang}}</td>
                            <td style="border-color:gainsboro!important;text-align:right">Rp. {{list.totalUangSaku}}</td>
                        </tr>
                    </tbody>
                    <tbody v-if="datas.length == 0">
                        <tr>
                            <td colspan="3" class="text-center">
                                {{errMessage}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { MonthPickerInput } from 'vue-month-picker'
import {DataApi} from "../service/DataApi";

export default {    
    components: {
        MonthPickerInput
    },
    data() {
        return {
            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            errMessage: '',
            datas: [],
            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),
            divisi: '',
        }
    },
    watch: {
        divisi() {
            this.page = 1
        },
        date() {
            this.page = 1
        },

    },
    methods: {
        getData() {
            this.$emit('flagDivisi', false)
            this.errMessage = 'Sedang Mencari Data ...'
            let payload = {
                limit: this.size,
                pageIn: this.page,
                divisi: this.divisi,
                bulan: this.date.monthIndex,
                tahun: this.date.year
            }
            DataApi.post("/magang/dashboard/satu", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = parseInt(response.data.totalRow)
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.errMessage = 'Maaf, Data Tidak Ditemukan'
                }
                this.$emit('flagDivisi', true)
            })
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year
            this.getData()
        },
        showDate(date) {
            this.date = date
        }
    },
    mounted() {
        this.setDate()
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px;
    margin-left: -64px;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}
</style>